import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { saveAs } from 'file-saver';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseListCtl } from '../common/base-list.component';
import { ServiceLocatorService } from '../common/service/service-locator.service';
import { CursorError } from '@angular/compiler/src/ml_parser/lexer';
import { GlobalConstants } from '../common/GlobalConstants ';

@Component({
  selector: 'app-attendance-list',
  templateUrl: './attendance-list.component.html',
  styleUrls: ['./attendance-list.component.css']
})
export class AttendanceListComponent extends BaseListCtl {

  constructor(public locator: ServiceLocatorService, private http: HttpClient, public route: ActivatedRoute) {
    super(locator.endpoints.ATTENDANCE, locator, route);
}

  excelData :any;
    downloadFile(): void {
      this.download()
        .subscribe(blob => saveAs(blob, 'AttendanceList.xlsx'));
    }

    download(): Observable<Blob> {
      let _self = this;
      let sid = localStorage.getItem( GlobalConstants.getKey('sessionId'));
      console.log(sid+'siddd' + this.form.searchParams);
      let url =  _self.locator.endpoints.ATTENDANCE+"/exportAttendanceList"+ ";jsessionid=" + sid;
      return this.http.post(url, this.form.searchParams, {
        responseType: 'blob'
      });

    }

//ID, EMPLOYEE_ID, NAME, A_YEAR, A_MONTH, NO_OF_DAYS (char(1)), DAY1, DAY2, DAY3, … DAY31, WDH1, WDh2…..,WDH31(float), 

  populateForm(form, data) {

    form.name = data.name;
    form.id = data.id;
    form.userId = data.userId;
    form.userName = data.userName;
    form.employeeId = data.employeeId;
    form.aYear = data.aYear;
    form.aMonth = data.aMonth;
    form.numOfDays = data.numOfDays;
    form.day1 = data.day1;
    form.day2 = data.day2;
    form.day3 = data.day3;
    form.day4 = data.day4;
    form.day5 = data.day5;
    form.day6 = data.day6;
    form.day7 = data.day7;
    form.day8 = data.day8;
    form.day9 = data.day9;
    form.day10 = data.day10;
    form.day11 = data.day11;
    form.day12 = data.day12;
    form.day13 = data.day13;
    form.day14 = data.day14;
    form.day15 = data.day15;
    form.day16 = data.day16;
    form.day17 = data.day17;
    form.day18 = data.day18;
    form.day19 = data.day19;
    form.day20 = data.day20;
    form.day21 = data.day21;
    form.day22 = data.day22;
    form.day23 = data.day23;
    form.day24 = data.day24;
    form.day25 = data.day25;
    form.day26 = data.day26;
    form.day27 = data.day27;
    form.day28 = data.day28;
    form.day29 = data.day29;
    form.day30 = data.day29;
    form.day31 = data.day31;

    form.wdh1 = data.wdh1;
    form.wdh2 = data.wdh2;
    form.wdh3 = data.wdh3;
    form.wdh4 = data.wdh4;
    form.wdh5 = data.wdh5;
    form.wdh6 = data.wdh6;
    form.wdh7 = data.wdh7;
    form.wdh8 = data.wdh8;
    form.wdh9 = data.wdh9;
    form.wdh10 = data.wdh10;
    form.wdh11 = data.wdh11;
    form.wdh12 = data.wdh12;
    form.wdh13 = data.wdh13;
    form.wdh14 = data.wdh14;
    form.wdh15 = data.wdh15;
    form.wdh16 = data.wdh16;
    form.wdh17 = data.wdh17;
    form.wdh18 = data.wdh18;
    form.wdh19 = data.wdh19;
    form.wdh20 = data.wdh20;
    form.wdh21 = data.wdh21;
    form.wdh22 = data.wdh22;
    form.wdh23 = data.wdh23;
    form.wdh24 = data.wdh24;
    form.wdh25 = data.wdh25;
    form.wdh26 = data.wdh26;
    form.wdh27 = data.wdh27;
    form.wdh28 = data.wdh28;
    form.wdh29 = data.wdh29;
    form.wdh30 = data.wdh29;
    form.wdh31 = data.wdh31;

    console.log('----->', data);
  }
  
}
